module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/14_c3840356130b3b87e4c4f8172b149e13.jpg";